import { createStyles, Theme } from "@material-ui/core";

export const styles = (theme: Theme) =>
    createStyles({
        fullScreenOverlay: {
            backgroundColor: theme.palette.background.overlay,
            bottom: 0,
            left: 0,
            position: "fixed",
            right: 0,
            top: 0,
            zIndex: theme.zIndex.modal
        }
    });
